import { getToken } from "../utils/auth";
import { API_BASE_URL } from "./URL_Header";

async function request(path, options = {}) {
  const response = await fetch(`${API_BASE_URL}${path}`, {
    ...options,
    headers: {
      Authorization: `Bearer ${getToken()}`,
      ...(options.body ? { "Content-Type": "application/json" } : {}),
      ...(options.headers || {}),
    },
  });
  const data = await response.json().catch(() => null);
  if (!response.ok) {
    const message = Array.isArray(data?.errors) ? data.errors.join("\n") : (data?.message || "تعذر تنفيذ الطلب");
    throw new Error(message);
  }
  return data;
}

async function uploadBody(path, body) {
  const response = await fetch(`${API_BASE_URL}${path}`, {
    method: "POST",
    headers: { Authorization: `Bearer ${getToken()}` },
    body,
  });
  const data = await response.json().catch(() => null);
  if (!response.ok) {
    throw new Error(data?.message || "تعذر رفع الصورة");
  }
  return data;
}

function uploadFile(path, file, fieldName) {
  const body = new FormData();
  body.append(fieldName, file);
  return uploadBody(path, body);
}

function uploadFiles(path, files) {
  const body = new FormData();
  files.forEach((file) => body.append("files", file));
  return uploadBody(path, body);
}

export const fetchAdminCollections = () => request("/Collections/admin");
export const fetchAdminCollection = (id) => request(`/Collections/admin/${id}`);
export const saveCollection = (id, body) => request(id ? `/Collections/${id}` : "/Collections", {
  method: id ? "PUT" : "POST",
  body: JSON.stringify(body),
});
export const archiveCollection = (id) => request(`/Collections/${id}`, { method: "DELETE" });
export const uploadCollectionCover = (id, file) => uploadFile(`/Collections/${id}/cover`, file, "file");
export const uploadCollectionGallery = (id, files) => uploadFiles(`/Collections/${id}/gallery`, files);
export const removeCollectionGallery = (id, path) => request(`/Collections/${id}/gallery`, {
  method: "DELETE",
  body: JSON.stringify({ path }),
});

export const fetchAdminBundles = () => request("/Bundles/admin");
export const fetchAdminBundle = (id) => request(`/Bundles/admin/${id}`);
export const saveBundle = (id, body) => request(id ? `/Bundles/${id}` : "/Bundles", {
  method: id ? "PUT" : "POST",
  body: JSON.stringify(body),
});
export const duplicateBundle = (id) => request(`/Bundles/${id}/duplicate`, { method: "POST" });
export const archiveBundle = (id) => request(`/Bundles/${id}`, { method: "DELETE" });
export const uploadBundleCover = (id, file) => uploadFile(`/Bundles/${id}/cover`, file, "file");
export const uploadBundleGallery = (id, files) => uploadFiles(`/Bundles/${id}/gallery`, files);
export const removeBundleGallery = (id, path) => request(`/Bundles/${id}/gallery`, {
  method: "DELETE",
  body: JSON.stringify({ path }),
});
export const fetchOrderBundles = (orderId) => request(`/Bundles/orders/${orderId}`);
export const fetchMerchandisingSummary = (days = 30) => request(`/Merchandising/summary?days=${days}`);

function catalogQuery(params) {
  const query = new URLSearchParams();
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;
    query.set(key, String(value));
  });
  return query.toString();
}

export const searchBundleCatalog = (params) => request(`/Bundles/catalog-search?${catalogQuery(params)}`);
export const fetchBundleCatalogIds = (params) => request(`/Bundles/catalog-ids?${catalogQuery(params)}`);
export const fetchBundleCatalogLabels = (kind, ids) => request("/Bundles/catalog-labels", {
  method: "POST",
  body: JSON.stringify({ kind, ids }),
});
